/* Euteyia — stock unique par couleur.
   Pour les produits tagués « stock-unique » : la variante « La paire » ajoute 2 pièces de la variante
   « L'unité » de la même couleur, et « La paire + boîte » ajoute en plus la boîte cadeau payante (la mini boîte reste le cadeau offert, ajouté par la cliente).
   « Le trio » ajoute 1 pièce de chaque taille (anneau). Les prix de la paire et du trio sont appliqués par une remise automatique Shopify. */
(function () {
  function low(s) { return String(s || '').toLowerCase(); }
  function isPair(v) { return /paire|pair|duo|2 unit/.test(low(v)); }
  function hasBox(v) { return /bo[iî]te|coffret|[ée]crin/.test(low(v)); }
  function isTrio(v) { return /trio/.test(low(v)); }
  // « Le trio » : 1 pièce « L'unité » de chaque taille, dans la couleur choisie.
  function trioItems(product, v, qi, names, qty) {
    var si = names.findIndex(function (n) { return /taille|size|diam/i.test(n); });
    if (si < 0) return null;
    var units = product.variants.filter(function (x) {
      return x.options.every(function (o, i) {
        if (i === qi) return !isPair(o) && !hasBox(o) && !isTrio(o);
        if (i === si) return true;
        return o === v.options[i];
      });
    });
    if (units.length < 2) return null;
    qty = Math.max(1, parseInt(qty, 10) || 1);
    for (var k = 0; k < units.length; k++) {
      if (window.EutStock && window.EutStock[units[k].id] !== undefined && window.EutStock[units[k].id] < qty) return { error: 'stock' };
    }
    return units.map(function (u) { return { id: u.id, quantity: qty, properties: { 'Format': 'Le trio' } }; });
  }
  window.EutPackItems = function (product, variantId, qty) {
    if (!product || !(product.tags || []).some(function (t) { return low(t) === 'stock-unique'; })) return null;
    var names = (product.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var qi = names.findIndex(function (n) { return /quantit/i.test(n); });
    if (qi < 0) return null;
    var v = (product.variants || []).find(function (x) { return String(x.id) === String(variantId); });
    if (!v) return null;
    var val = v.options[qi];
    if (isTrio(val)) return trioItems(product, v, qi, names, qty);
    var pair = isPair(val), box = hasBox(val);
    if (!pair && !box) return null;
    var unit = product.variants.find(function (x) {
      return x.options.every(function (o, i) { return i === qi ? (!isPair(o) && !hasBox(o) && !isTrio(o)) : o === v.options[i]; });
    });
    if (!unit) return null;
    qty = Math.max(1, parseInt(qty, 10) || 1);
    var need = (pair ? 2 : 1) * qty;
    if (window.EutStock && window.EutStock[unit.id] !== undefined && window.EutStock[unit.id] < need) return { error: 'stock' };
    var items = [{ id: unit.id, quantity: (pair ? 2 : 1) * qty, properties: { 'Format': pair ? (box ? 'La paire + boîte' : 'La paire') : 'L\'unité + boîte' } }];
    if (box) {
      if (!window.EutBoxId) return { error: 'box' };
      items.push({ id: window.EutBoxId, quantity: qty });
    }
    return items;
  };
})();

/* Paniers commencés avant le stock unique (29/10/2026) : une ancienne ligne « La paire » / « + boîte » (variante
   achetée telle quelle, sans « Format ») ne décompte aucune pièce. À l'ouverture d'une page, on la remplace par
   les pièces « L'unité » (+ boîte cadeau), comme si elle venait d'être ajoutée depuis la fiche. */
(function () {
  var OLD = /paire|pair|duo|bo[iî]te|coffret|[ée]crin|trio/i;
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
  }
  function skipped() { try { return JSON.parse(sessionStorage.getItem('eut_old_ok') || '[]'); } catch (e) { return []; } }
  function skip(key) { try { var k = skipped(); k.push(key); sessionStorage.setItem('eut_old_ok', JSON.stringify(k)); } catch (e) {} }
  function repairLine(it) {
    return fetch('/products/' + it.handle + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (product) {
      if (!product || !window.EutPackItems) return false;
      if (!window.EutBoxId) window.EutBoxId = 57288923251019; // Boîte cadeau Euteyia
      var stock = window.EutStock; window.EutStock = null; // le contrôle de stock se fait à l'ajout
      var items = window.EutPackItems(product, it.variant_id, it.quantity);
      window.EutStock = stock;
      if (!items || !items.length) { skip(it.key); return false; }
      // la clé d'une ligne change quand le panier bouge : on relit le panier avant de retirer l'ancienne ligne,
      // puis on ajoute les pièces (si elles sont refusées faute de stock, l'ancienne ligne part quand même)
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        var line = (cart.items || []).find(function (x) { return x.variant_id === it.variant_id && !(x.properties && x.properties.Format); });
        return line ? post('/cart/change.js', { id: line.key, quantity: 0 }) : null;
      }).then(function () {
        return post('/cart/add.js', { items: items });
      }).then(function () { return true; });
    }).catch(function () { return false; });
  }
  function run() {
    if (!window.fetch || /^\/checkouts?\//.test(location.pathname)) return;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var old = (cart.items || []).filter(function (it) {
        return OLD.test(it.variant_title || '') && !(it.properties && it.properties.Format) && skipped().indexOf(it.key) < 0;
      });
      if (!old.length) return;
      var chain = Promise.resolve(false);
      old.forEach(function (it) {
        chain = chain.then(function (done) { return repairLine(it).then(function (ok) { return done || ok; }); });
      });
      return chain.then(function (done) {
        if (done) document.dispatchEvent(new CustomEvent('cart:refresh'));
      });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
